<template>
    <div class="w-100">
        <div class="d-flex flex-wrap negative-y-margin" v-if="batches && batches.length > 0" style="font-size: 0.7em;">
            <template v-for="(batch, index) in batches">
                <batches-panel-slot
                :batch="batch.batch"
                :index="index"
                :currentlyActiveBatch="currentlyActiveBatch"
                :width_class="columnWidthClass"
                :currentDate="currentDate"
                @selected="batchSelected"></batches-panel-slot>
            </template>
        </div>
        <div v-else>{{transEdit('no-active-schedules-for-day')}}</div>
    </div>
</template>

<script>
    import BatchesPanelSlot from "./BatchesPanelSlot";

    export default {
        name: "batches-panel",
        components: {BatchesPanelSlot},
        props: ['route_refresh', 'batches', 'initialBatch', 'currentDate'],
        data: function () {
            return {
                numberOfColumns: 2,
                currentlyActiveBatch: this.initialBatch,
            };
        },
        computed: {
            columnWidth () {
                return 12 / this.numberOfColumns;
            },
            columnWidthClass () {
                return "col-" + this.columnWidth;
            }
        },
        methods: {
            setActiveBatchToNull () {
                this.currentlyActiveBatch = null;
            },
            batchSelected (message) {
                this.currentlyActiveBatch = message.batch;
                this.$emit('selected', {
                    batch: message.batch,
                });
            },
        }, mounted () {
            this.hasBeenMounted = true;
        }
    }
</script>

<style scoped>
    .negative-y-margin {
        margin-left: -8px;
        margin-right: -8px;

    }
</style>